export default "__VITE_ASSET__D05opuaL__"